<template>
    <div class="container">
        <div class="container-header">
            <div class="search">
                <div class="search-form">
                    <div class="form-item">
                        <span class="form-item-lable">{{ $t('userName') }}</span>
                        <el-autocomplete v-model="usernameText"
                                         clearable
                                         size="mini"
                                         :fetch-suggestions="queryUsername"
                                         :placeholder="$t('pleaseInputHint')"
                                         @select="usernameSelect"
                                         @clear="usernameClear"></el-autocomplete>
                    </div>
                    <div class="form-item">
                        <span class="form-item-lable">{{ $t('activityName') }}</span>
                        <el-autocomplete v-model="activityText"
                                         clearable
                                         size="mini"
                                         :fetch-suggestions="queryActivity"
                                         :placeholder="$t('pleaseInputHint')"
                                         @select="activitySelect"
                                         @clear="activityClear"></el-autocomplete>
                    </div>
                </div>
                <div class="search-handle">
                    <el-button type="primary"
                               size="mini"
                               @click="searchHandle">{{ $t('search') }}</el-button>
                    <el-button type="primary"
                               size="mini"
                               @click="emptyHandle">{{ $t('empty') }}</el-button>
                </div>
            </div>
        </div>
        <div class="container-main">
            <el-table :data="tableData"
                      border
                      style="width: 100%">
                <el-table-column type="index"
                                 align="center"
                                 width="60"></el-table-column>
                <el-table-column min-width="260"
                                 :label="$t('employeeInfo')">
                    <template slot-scope="scope">
                        <div class="info">
                            <el-image :src="scope.row.user.avatar"
                                      v-if="scope.row.user">
                                <div slot="error"
                                     class="image-slot">
                                    <img src="../../assets/images/logo.png"
                                         alt="">
                                </div>
                            </el-image>
                            <img src="../../assets/images/logo.png"
                                 alt=""
                                 v-else>
                            <div class="desc avatar-desc">
                                <template v-if="scope.row.user">
                                    <p class="desc-item">{{ scope.row.user.username }}</p>
                                    <p class="desc-item"
                                       v-if="scope.row.user.email">{{ scope.row.user.email }}</p>
                                    <p class="desc-item"
                                       v-if="scope.row.user.mobile">{{ scope.row.user.mobile }}</p>
                                </template>
                                <p class="desc-item"
                                   v-else>{{ $t('defaultUser') }}</p>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('activityName')"
                                 align="center"
                                 min-width="220"
                                 show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.activity">{{ scope.row.activity.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('lotteryTime')"
                                 align="center"
                                 width="180"
                                 show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.activity">{{ scope.row.activity.luckyDrawAt | formatDate }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="code"
                                 :label="$t('lotteryCode')"
                                 align="center"
                                 width="160"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="signIn"
                                 :label="$t('ifCheckin')"
                                 align="center"
                                 width="160"
                                 show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.signIn">{{ $t('yes') }}</span>
                        <span v-else>{{ $t('no') }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="selected"
                                 :label="$t('ifWinning')"
                                 align="center"
                                 width="150"
                                 show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.selected">{{ $t('yes') }}</span>
                        <span v-else>{{ $t('no') }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background
                           :current-page="currentPage"
                           layout="sizes, prev, pager, next, total"
                           :page-sizes="[10, 15, 20, 50, 100]"
                           :page-size="pageSize"
                           :total="total"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { queryLotteryPartici, searchLotteryActivity, searchUserList } from "@/api/modules/api";

export default {
    name: "LotteryPartici",
    // 组件
    components: {

    },
    props: {},
    data () {
        return {
            usernameText: '',
            activityText: '',
            search: {
                userId: '',
                activityId: ''
            },
            tableData: [],
            currentPage: 1,
            total: 0,
            pageSize: 10,
        };
    },
    // 计算属性
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        // 获取数据列表
        getListData () {
            const params = {
                userId: this.search.userId.trim(),
                activityId: this.search.activityId.trim(),
                page: this.currentPage,
                size: this.pageSize
            }
            queryLotteryPartici(params).then(res => {
                if (Number(res.code) === 20000) {
                    this.tableData = res.data.list
                    this.total = res.data.total
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch(err => {
                this.$message.error(err)
            })
        },
        // 远程搜索用户
        queryUsername (queryString, cb) {
            if (!queryString) {
                cb([])
                return;
            }
            const params = {
                username: queryString,
            }
            searchUserList(params).then(res => {
                if (Number(res.code) === 20000) {
                    const resData = res.data.map(item => {
                        return {
                            value: item.username,
                            id: item.id
                        }
                    })
                    cb(resData)
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch(err => {
                this.$message.error(err)
            })
        },
        // 选择用户
        usernameSelect (val) {
            this.search.userId = val.id
            this.searchHandle()
        },
        // 远程搜索活动
        queryActivity (queryString, cb) {
            if (!queryString) {
                cb([])
                return;
            }
            const params = {
                name: queryString,
            }
            searchLotteryActivity(params).then(res => {
                if (Number(res.code) === 20000) {
                    const resData = res.data.map(item => {
                        return {
                            value: item.name,
                            id: item.id
                        }
                    })
                    cb(resData)
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch(err => {
                this.$message.error(err)
            })
        },
        // 选择活动
        activitySelect (val) {
            this.search.activityId = val.id
            this.searchHandle()
        },
        // 清除用户搜素
        usernameClear () {
            this.search.userId = ''
            this.searchHandle()
        },
        // 清除活动搜素
        activityClear () {
            this.search.activityId = ''
            this.searchHandle()
        },
        // 搜索
        searchHandle () {
            // 当前页码初始化
            this.currentPage = 1
            // 获取列表数据
            this.getListData()
        },
        // 清空
        emptyHandle () {
            this.usernameText = ''
            this.activityText = ''
            this.search = {
                userId: '',
                activityId: ''
            }
            this.currentPage = 1
            // 获取列表数据
            this.getListData()
        },
        // 切换页码
        handleCurrentChange (page) {
            // 设置页码
            this.currentPage = page
            // 获取列表数据
            this.getListData()
        },
        // 切换显示条数
        handleSizeChange (size) {
            // 设置大小
            this.pageSize = size
            // 初始化页码
            this.currentPage = 1
            // 获取列表数据
            this.getListData()
        }
    },
    // 创建完成
    created () {
    },
    // 挂载完成
    mounted () {
        // 获取列表数据
        this.getListData()
    },
    // 销毁之前
    beforeDestroy () {
    },
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/base-column.scss';
</style>
